"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetButton = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const hooks_1 = require("../../../../store/hooks");
const thresholdSlice_1 = require("../../../../store/thresholdSlice");
const ReturnArrowIcon_1 = require("./Icons/ReturnArrowIcon");
const ThresholdButton_1 = require("./ThresholdButton");
const ResetButton = ({ variant = ThresholdButton_1.ThresholdButtonVariant.IconOnly, resetButtonText, swapIconTextPosition = false, useDarkBlueIcon = false, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, hooks_1.useAppDispatch)();
    const resetButtonDefaultText = t("thresholdConfigurator.resetButtonDesktop");
    const finalResetButtonText = resetButtonText || resetButtonDefaultText;
    const resetThresholds = () => {
        dispatch((0, thresholdSlice_1.resetUserThresholds)());
    };
    return (react_1.default.createElement(ThresholdButton_1.ThresholdButton, { variant: variant, buttonText: finalResetButtonText, swapIconTextPosition: swapIconTextPosition, useDarkBlueIcon: useDarkBlueIcon, IconComponent: ReturnArrowIcon_1.ReturnArrowIcon, onClick: resetThresholds }));
};
exports.ResetButton = ResetButton;
